<template>
  <div class="profile-pic-container">
    <div
      :style="`background-image:url(${item.image ? imgurl(item.image.file_url, 'full') : '../../static/img/default_profile.png'})`"
      class="profile-pic"
    />
  </div>
</template>

<script>
  export default {
    name: 'ProfilePictureComponent',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .profile-pic-container {
    .profile-pic {
      width: 200px;
      height: 200px;
      border: 1px solid $white;
      background: {
        size: cover;
        position: center;
      }
    }

    a {
      display: block;
      max-width: 180px;
    }
  }

  @include editable-max-width(765px) {
    .profile-pic {
      width: 100px;
      height: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProfilePicture.vue